import { BroadcastChannel } from 'broadcast-channel';
import React, { useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import {
  EKYC_BRODCAST_CHANNEL,
  EKYC_BRODCAST_MESSAGE,
} from 'shared/constants/ekyc';
import Button from 'shared/modules/common/components/atoms/Button';
import Icon from 'shared/modules/common/components/atoms/Icon';
import Modal from 'shared/modules/common/components/atoms/Modal';

const EKYCAbandonedJourneyDialog = (props: {
  open: boolean;
  onClose: () => void;
  onDialogClose?: () => void;
  onNextButtonPress: () => void;
}) => {
  const { open, onNextButtonPress, onClose } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  let bc: BroadcastChannel;

  useEffect(() => {
    /**
     * These code snippets serves as a listener which navigate to account page
     * when EKYC Application is completed.
     */
    bc = new BroadcastChannel(EKYC_BRODCAST_CHANNEL);

    bc.onmessage = (msg) => {
      if (msg === EKYC_BRODCAST_MESSAGE.NAVIGATE_TO_ACCOUNT) {
        onClose?.();
        window.location.assign(`${process.env.MY_PAIDY_URL}/account`);
      }
    };

    return () => {
      bc.close();
    };
  }, []);

  return (
    <Modal
      style={[styles.modal, !isBigScreen && styles.modalSmallScreen]}
      open={open}
      showBackButton={true}
      showCloseButton={true}
      showPaidyLogo={false}
      id="ekyc-abandoned-journey"
      title=""
      onCloseButtonPress={onClose}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}
    >
      <View>
        <Text style={styles.title}>{`本人確認手続きが\n中断されました`}</Text>
        <Text style={styles.body}>
          {`本人確認が完了すると、3・6・12回あと払い\nが利用可能になり、月々のお支払いを自分の\nペースで調整できるようになります。`}
        </Text>
        <View style={styles.optionView}>
          <View style={styles.iconWithTextViewPd12}>
            <Icon name="circle-yen" size="24" style={styles.circleYenIcon} />
            <Text style={styles.optionText}>
              <Text
                style={{ fontWeight: '600', paddingBottom: 8 }}
              >{`3・6・12回あと払いが分割手数料無料`}</Text>
              {`\n（口座振替・銀行振込のみ無料）`}
            </Text>
          </View>
        </View>
        <Text style={styles.body}>
          {`前回の続きから本人確認を再開できます。`}
        </Text>
      </View>
      <View
        style={[styles.buttonContainer, isBigScreen && { paddingVertical: 60 }]}
      >
        <Button
          variant="primary"
          title="本人確認を再開する"
          onPress={onNextButtonPress}
          style={styles.nextButton}
          id="ekyc-abandoned-journey-next-button"
        />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modal: {
    width: '100%',
    maxWidth: 424,
    minHeight: 500,
    marginTop: 90,
    height: 700,
  },
  modalSmallScreen: {
    minHeight: '100%',
    borderRadius: 0,
    marginTop: 0,
  },
  nextButton: {
    alignSelf: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 24,
  },
  body: {
    fontSize: 16,
    fontWeight: '300',
  },
  optionView: {
    padding: 12,
    borderWidth: 1.5,
    borderColor: '#fff',
    borderRadius: 16,
    backgroundColor: '#fff',
    marginVertical: 16,
  },
  circleYenIcon: {
    width: 24,
    height: 24,
    marginRight: 6,
  },
  iconWithTextViewPd12: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  optionText: {
    fontSize: 13,
    fontWeight: '300',
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
});

export default EKYCAbandonedJourneyDialog;
